import { isImageTypeSupported, getDefaultImageType } from '../parsed-image-api/image-type';
export default function getImageOutputFormat() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var imageOptions = options.image || {};
  var type = imageOptions.type || 'auto';

  switch (type) {
    case 'imagebitmap':
    case 'html':
    case 'ndarray':
      if (!isImageTypeSupported(type)) {
        throw new Error("Requested image type ".concat(type, " not available in current environment"));
      }

      return type;

    case 'auto':
      return getDefaultImageType();

    default:
      throw new Error("Unknown image format ".concat(type));
  }
}